import freshPng from './fresh-optimized.png';
import freshJp2 from './fresh.jp2';
import freshWebP from './fresh.webp';
import kibblePng from './kibble-optimized.png';
import kibbleJp2 from './kibble.jp2';
import kibbleWebP from './kibble.webp';
import meatvegPng from './meatveg-optimized.png';

export const freshSources = [freshWebP, freshJp2, freshPng];
export const kibbleSources = [kibbleWebP, kibbleJp2, kibblePng];
export const meatvegSources = [meatvegPng];
